import clevertap from 'clevertap-web-sdk';

const ClevertapReact = {
	initialize: function (accountId) {
		clevertap.setLogLevel(Number(process.env.REACT_APP_CLEVERTAP_LOG_LEVEL) || 0);
		clevertap.init(accountId);
	},

	event: function (name, payload = null) {
		clevertap.event.push(name, payload);
	},

	profile: function (payload) {
		clevertap.profile.push(payload);
	},

	onUserLogin: function (payload = null) {
		clevertap.onUserLogin.push(payload);
	},

	logout: function () {
		clevertap.logout();
	},
};

export default ClevertapReact;
